<!-- START Top Navbar-->
<nav class="navbar topnavbar" role="navigation">
    <!-- START navbar header yourcab-logo-mini.png -->
    <div class="navbar-header">
      <a class="navbar-brand" style="color: #fff; cursor: pointer;">
        <div class="brand-logo" [routerLink]="'/home'">
          <img class="img-fluid" src="assets/img/Artboard.png" alt="" style="max-width: 160px;
    margin-top: -14px;" />
        </div>
        <div class="brand-logo-collapsed" [routerLink]="'/home'">
          <img class="img-fluid" src="assets/img/logo-abd-white-mini.png" alt="" style="max-height: 50px;" />
        </div>
      </a>
    </div>
    <!-- END navbar header-->
    <!-- START Left navbar-->
    <ul class="navbar-nav mr-auto flex-row">
      <li class="nav-item" style="cursor: pointer;">
        <!-- Button used to collapse the left sidebar. Only visible on tablet and desktops-->
        <a class="nav-link d-none d-md-block d-lg-block d-xl-block" trigger-resize="" (click)="toggleCollapsedSideabar()" *ngIf="!isCollapsedText()">
          <em class="fas fa-bars"></em>
        </a>
        <!-- Button to show/hide the sidebar on mobile. Visible on mobile only.-->
        <a class="nav-link sidebar-toggle d-md-none" (click)="settings.toggleLayoutSetting('asideToggled'); $event.stopPropagation()">
          <em class="fas fa-bars"></em>
        </a>
      </li>
    </ul>

    <ul class="navbar-nav mr-auto flex-row no_display_onmobile no_display_tablet">
      <li class="nav-item" style="color: #ce1b1b;">
        <div class="media mt-0" [routerLink]="'/home'" style="cursor: pointer;">
          <h5 class="m-0 text-bold" style="line-height: 2.1;font-size: 18px;">
            <em class="mr-2 far fa-clock"></em><p now format="DD/MM/YYYY HH:mm A"></p>  <span *ngIf="week"> | Semaine {{week}}</span>
          </h5>
        </div>
      </li>
    </ul>


    <ul class="navbar-nav flex-row">
      <li class="nav-item">
        <div class="media mt-0" style="padding-top: 10px;;cursor: pointer;">

          <div class="mr-3 img-profil__photo32" *ngIf="!currentUser?.image"
               [innerHTML]="currentUser?.firstName|user2Lettre:currentUser?.lastName"></div>
          <img class="mr-2 img-thumbnail rounded-circle thumb32"
               *ngIf="currentUser?.image" src="{{currentUser?.image}}"
               alt="Image" appImgFallback="assets/img/avatar.svg"/>
          <div class="media-body no_display_onmobile">
            <h5 class="m-0 text-bold" style="line-height: 1.5;color: #ce1b1b;">
              <span [innerHTML]="currentUser?.firstName"></span> &nbsp;<span [innerHTML]="currentUser?.lastName"></span>
              | {{currentUser?.role}} | {{currentUser?.activity}}<br/>
              <small><app-show-equipe [ids]="currentUser?.equipes"></app-show-equipe></small>
            </h5>
          </div>
        </div>
      </li>
      <!--
      <li class="nav-item">
        <a class="nav-link" (click)="pause(); $event.stopPropagation()" style="cursor: pointer">
          <em class="mr-2 far fa-pause-circle"></em>
        </a>
      </li>-->
      <li class="nav-item">
        <a class="nav-link" (click)="logout(); $event.stopPropagation()" style="cursor: pointer">
          <em class="fa fa-power-off"></em>
        </a>
      </li>
    </ul>

</nav>
<!-- END Top Navbar-->
